<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-header-title">
          {{ $t('Divide the profits of the partners') }}
        </h4>
        <router-link
          :to="'/partnersProfits/create?partner_id=' + $route.params.id"
          class="btn btn-sm btn-primary"
        >
          <i class="fas fa-plus"></i> {{ $t('addition') }}
        </router-link>
      </div>
      <indexTable
        :searchText="$t('Search for a process')"
        :emptyTableText="$t('There are no profit splits at the moment')"
        :filter="{ partner_id: $route.params.id }"
        :emptyTableSubText="$t('Try adding some and try again')"
        :withoutCard="true"
        :cloumns="[
          {
            column: 'code',
            title: $t('reference'),
            type: 'mainLink',
            sort: true
          },
          {
            column: 'safe_id',
            title: $t('Project'),
            type: 'link',
            to: 'project',
            sort: true,
            link: true
          },
          { column: 'date', title: $t('date'), type: 'text', sort: true },
          { column: 'total', title: $t('The amount'), type: 'text', sort: true },
          {
            column: 'description',
            title: $t('That about'),
            type: 'text',
            sort: true
          },
          {
            column: 'options',
            title: $t('actions'),
            type: 'options',
            options: [
              { name: 'show' },
              {
                name: 'edit',
                role: $checkRole('partners_profits_edit')
              },
              {
                name: 'delete',
                role: $checkRole('partners_profits_delete')
              }
            ]
          }
        ]"
        :deleteText="{
          attention: $t('Attention'),
          areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
          close: $t('Close'),
          confirm: $t('Confirm'),
          loading: $t('Loading')
        }"
      />
    </div>
  </div>
</template>
<script>
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/partnersProfits'
    }
  },
  components: {
    indexTable
  }
}
</script>
